/**
 *  Module
 *
 * Description :iwo 公共服务
 ** Author:wang.jiang 2016-2-21
 */

'use strict';
angular.module('iWoServiceModule', []).factory('iWoService', [
    '$q',
    '$modal',
    'trsHttpService',
    'fusionParams',
    'fusionApiService',
    'localStorageService',
    'modalDialog',
    '$interval',
    '$rootScope',
    '$state',
    'iWoConst',
    'editingCenterService',
    'mediaIconObj',
    function ($q, $modal, trsHttpService, fusionParams, fusionApiService, localStorageService, modalDialog, $interval, $rootScope, $state, iWoConst, editingCenterService, mediaIconObj) {

        /**
         * [sendmessage description] 发送函数
         * @param  {[type]}  scope   [scope description]
         * @return  {[type]}   [return description]
         */
        function sendmessage(scope) {
            const outerSourceId = scope.list.METADATAID;
            const title = scope.list.TITLE;
            let articleDocType = scope.list.DOCTYPEID || editingCenterService.getDocTypeId();
            let articleMediaType = scope.list.MEDIATYPE || editingCenterService.getEditPageMediaType();
            const operType = initIWOOperType();
            // let url = getDetailUrl(articleDocType, articleMediaType);
            const extraInfo = {
                'articleDocType': articleDocType,
                'articleMediaType': articleMediaType,
                // 'articleUrl': url,
                'oprType': operType,
                'chnlDocId': scope.list.CHNLDOCID
            };
            const info = {
                messageBody: {
                    content: '',
                    extraInfo: JSON.stringify(extraInfo),
                    messageType: 'ARTICLE_DOC',
                    outerSourceId: outerSourceId,
                    platform: '',
                    title: title
                },
                outerSourceId: '',
                oprType: operType,
                objId: ''
            };
            editingCenterService.sendToStudio(info).then(function (result) {
                if (result.ISSUCCESS === 'true') {
                    setTimeout(() => {
                        window.close();
                    }, 2000);
                }
            });
        }
        return {
            addFuture: function (vm, methodNameList) {
                for (var i = 0; i < methodNameList.length; i++) {
                    let methodName = methodNameList[i];
                    vm[methodName] = this[methodName];
                }
                return vm;
            },
            sendmessage: function (scope) {
                let that = this;
                scope = scope || that.data.navs[0].controller.$scope;
                if (this.save) {
                    this.save(true).then((data) => {
                        sendmessage(scope);
                    });
                } else {
                    sendmessage(scope);
                }
            },
            getPicsDoc: function (metadataid) {
                var params = {
                    serviceid: 'mlf_myrelease',
                    methodname: 'getPicsDoc',
                    MetaDataId: metadataid,
                };
                return trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get');
            },
            initData: function () {
                return trsHttpService.httpServer('./editingCenter/properties/metadataEnum.json', {}, 'get');
            },
            submit: function (list) {
                list.serviceid = 'mlf_myrelease';
                list.methodname = 'savePicsDoc';
                return trsHttpService.httpServer('/wcm/mlfcenter.do', list, 'post');
            },
            exportDraft: function (metaDataIds) {
                var params_1 = {
                    serviceid: 'mlf_exportword',
                    methodname: 'exportWordFile',
                    MetaDataIds: metaDataIds,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params_1, 'post').then(function (data) {
                    window.open(data);
                });
            },

            /**
             * [copyBuildDraft description] 复制建新稿1
             * @param  {[type]} array      [description] 对象集合
             * @param  {[type]} methodname [description] 方法名
             * @param  {[type]} success    [description] 是否回调
             * @return {[type]}            [description]
             */
            copyBuildDraft: function (array, methodname, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/iWo/service/copyBuildDraft/copyBuildDraft_tpl.html',
                    windowClass: 'copyBuildDraftMain',
                    backdrop: false,
                    controller: 'copyBuildDraftCtrl',
                    resolve: {
                        array: function () {
                            return array;
                        },
                        methodname: function () {
                            return methodname;
                        },
                    },
                });
                modalInstance.result.then(function (result) {
                    if (result === 'success') {
                        success();
                    }
                });
            },

            /**
             * [initEditPath description] 初始化编辑页的路由
             * @return {[object]} [description] 1：新闻编辑页；2：图集编辑页
             */
            initEditPath: function () {
                var editPath = {
                    1: 'iwonews',
                    2: 'iwoatlas',
                };
                return editPath;
            },

            /**
             * [initPreviewPath description] 初始化预览页路由
             * @return {[object]} [description] 1：新闻预览页；2：图集预览页
             */
            initPreviewPath: function () {
                var previewPath = {
                    1: 'iWoNewsPreview',
                    2: 'iWoAtlasPreview',
                };
                return previewPath;
            },

            /**
             * [fusionAll 融合稿件批量操作]
             * @param   {[type]}  oprType    [oprType 融合类型-daishen:待审， daibian：待编]
             * @param   {[type]}  actionKey  [actionKey 操作类型- qianfa: 全部签发， songshen-全部送审， chegao-全部撤稿]
             * @param   {[type]}  params     [params description]
             * @return  {function}           [return description]
             */
            fusionAll: function (oprType, actionKey, params) {
                let defer = $q.defer();
                if (isSameFusionAllRuning(oprType, actionKey)) {
                    modalDialog.alertType('上一个批量任务尚未完成，请稍后再尝试此操作', '', 'warning', false, function () { });
                    defer.reject();
                    return defer.promise;
                }
                let requestParams = angular.extend({}, fusionParams.fusionAllParams, {
                    oprType: oprType,
                    actionKey: actionKey,
                    mediaTypes: params.mediaTypes,
                    OprTime: params.OprTime,
                });
                fusionApiService.fusionAll(requestParams).then(function (data) {
                    if (data.TASKID) {
                        modalDialog.alertType('批量签发任务已创建', '', 'success', false, function () {
                            let task = {
                                taskId: data.TASKID,
                                mediaTypes: params.mediaTypes,
                                actionKey: actionKey,
                                oprType: oprType
                            };
                            addTaskToStorage(task);
                        });
                        defer.resolve(data);
                    } else {
                        defer.reject(data);
                    }
                });
                return defer.promise;
            },

            /**
             * [getFusionStatus 获取融合批量任务的执行状态]
             * @param   {[type]}  taskId  [taskId description]
             * @return  {function}        [return description]
             */
            getFusionStatus: function (taskId) {
                let defer = $q.defer();
                let params = angular.extend({}, fusionParams.fusionStatusParams, {
                    taskId: taskId
                });
                fusionApiService.getFusionStatus(params).then(function (data) {
                    if (data.RUN_MARK === fusionParams.fusionTaskStatus.finish) {
                        clearFinishedFasionTask(taskId);
                        modalDialog.multiReportsAlert(data.DATA, function () {
                            fusionUnlock(taskId);
                            defer.resolve(data);
                        });
                    } else {
                        defer.reject(data);
                    }
                });
                return defer.promise;
            },

            /**
             * [shareObj description] 组装共享参数
             * @param   {[type]}  shareObj  [shareObj description]
             * @return  {[type]}            [return description]
             */
            packageShareParams: function (shareObj) {
                let shareMethod = [iWoConst.personalShare, iWoConst.receiveShare];
                let fromType = $state.params.fromType || $state.params.iwoplatform;
                let methodName;
                if (fromType === 'departmentmanuscript') {
                    methodName = iWoConst.deptShare;
                } else {
                    methodName = shareMethod[fromType];
                }
                let shareParams = angular.extend(shareObj, methodName);
                shareParams.MetaDataIds = $state.params.iwometadataid;
                shareParams.ChnlDocIds = $state.params.iwochnldocid;
                shareParams.departmentaldocId = $state.params.departmentaldocid || $state.params.departmentDocId;
                return shareParams;
            },

            /**
             * [getRelatedMediaIcon description] 获取融合稿件相关渠道的图标
             * @param   {[object]}  relatedMedia  [relatedMedia description] 融合渠道信息
             * @return  {[type]}                  [return description]
             */
            getRelatedMediaIcon: function (relatedMedia) {
                let iconObj = {};
                if (relatedMedia.SUBMITSTATUS * 1 === 1) {
                    iconObj = mediaIconObj.iconObj;
                } else {
                    iconObj = mediaIconObj.highlightIconObj;
                }
                relatedMedia.icon = iconObj[relatedMedia.MEDIATYPE];
            },

            // 用于获取融合待编和融合审签的渠道，但是目前共享稿库推荐渠道和取签产品也在用这个接口（去掉全部）
            getProducts: function() {
                var params = {
                    ServiceId: 'mlf_fusion',
                    Methodname: 'queryFusionMediaTypes',
                };
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get');
            }
        };

        /**
         * [initIWOOperType description] 初始化iwo的opertype，用于鉴权，主要是传给im
         *
         * @return  {[type]}   [return description]
         */
        function initIWOOperType() {
            const operTypeObj = {
                departmentmanuscript: 'deptmentaldoc.deptmentaldoc',
                0: 'iwo.personal',
                1: 'iwo.received',
                2: 'iwo.docrecord'
            };
            return operTypeObj[$state.params.fromType || $state.params.iwoplatform];
        }

        /**
         * [getDetailUrl 获取预览页]
         *
         * @param   {[type]}  doctypeID    [doctypeID description]
         * @param   {[type]}  mediatypeID  [mediatypeID description]
         *
         * @return  {[type]}               [return description]
         */
        function getDetailUrl(doctypeID, mediatypeID) {
            let baseUrl = window.location.origin + '/xjmediaCloud/#/';
            let previewUrl = '';
            previewUrl += `fusionpreview?iwometadataid=${$state.params.iwometadataid}&iwochnldocid=${$state.params.iwochnldocid}&iwotype=${doctypeID}&iwomodalname=iwo.personal&appchannelid=${$state.params.appchannelid}&appsiteid=${$state.params.appsiteid}&appplatform=${$state.params.appplatform}&appdoctype=${doctypeID}&wzchannelid=${$state.params.wzchannelid}&wzsiteid=${$state.params.wzsiteid}&wzplatform=${$state.params.wzplatform}&wztypeid=1&paperid=${$state.params.paperid}&newspapertype=${$state.params.newspapertype}&wxplatform=${$state.params.wxplatform}&iwoplatform=${$state.params.iwoplatform}`;
            return baseUrl + previewUrl;
        }

        /**
         * [fusionUnlock 融合审签任务解锁]
         *
         * @param   {[type]}  taskId  [taskId description]
         *
         * @return  {[type]}          [return description]
         */
        function fusionUnlock(taskId) {
            let unLockParams = fusionParams.unLockParams;
            unLockParams.taskId = taskId;
            fusionApiService.unLock(unLockParams);
        }

        /**
         * [addTaskToStorage 将正在进行的任务添加到缓存中]
         *
         * @param   {[type]}  task  [task description]
         *
         * @return  {[type]}        [return description]
         */
        function addTaskToStorage(task) {
            let fusionAllStorage = localStorageService.get('fusionAllStorage');
            if (!fusionAllStorage) {
                fusionAllStorage = [];
            }
            fusionAllStorage.push(task);
            localStorageService.set('fusionAllStorage', fusionAllStorage);
        }

        /**
         * [clearFinishedFasionTask 清除已完成的融合批量任务]
         *
         * @param   {[type]}  taskId  [taskId description]
         *
         * @return  {[type]}          [return description]
         */
        function clearFinishedFasionTask(taskId) {
            $interval.cancel($rootScope.fusionAllStatusTimer);
            $rootScope.fusionAllStatusTimer = undefined;
            let fusionAllStorage = localStorageService.get('fusionAllStorage');
            fusionAllStorage.forEach(function (item, index) {
                if (item.taskId === taskId) {
                    fusionAllStorage.splice(index, 1);
                    if (fusionAllStorage.length) {
                        localStorageService.set('fusionAllStorage', fusionAllStorage);
                    } else {
                        localStorageService.remove('fusionAllStorage');
                    }
                }
            });
        }

        /**
         * [isSameFusionAllRuning 判断是否存在同类型的融合批量任务正在进行]
         * @param   {[type]}  oprType    [oprType description]
         * @param   {[type]}  actionKey  [actionKey description]
         * @return  {[type]}             [return description]
         */
        function isSameFusionAllRuning(oprType, actionKey) {
            let sameOper = false;
            let fusionAllStorage = localStorageService.get('fusionAllStorage');
            if (fusionAllStorage && fusionAllStorage.length) {
                fusionAllStorage.forEach(function (item) {
                    if (oprType === item.oprType && actionKey === item.actionKey) {
                        sameOper = true;
                    }
                });
            }
            return sameOper;
        }
    },
]);
